import {Trans, useTranslation, withTranslation} from "react-i18next";
import React from "react";

import {Field, Form, withFormik} from 'formik';
import * as Yup from 'yup'
import {TextField} from 'formik-material-ui';

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {useCheckout} from "../../../Providers/CheckoutProvider";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  margin: {
    marginBottom: theme.spacing(1)
  },
}));

const TextFieldWithMargin = (props) => {
  const classes = useStyles();
  return <TextField className={classes.margin} {...props} />
}


const StorePickupForm = ({addOrEdit, isValid}) => {
  const { state } = useCheckout();
  const {t} = useTranslation();

  return (
    <Form>
      <Field component={TextFieldWithMargin} name='name' label={t('Your name')}  fullWidth/>
      <Field component={TextFieldWithMargin} name='mobile' label={t('Mobile number')}   fullWidth />
      <Field component={TextFieldWithMargin} name='email' label={t('Email address')}  fullWidth />

      <Box mt={2} mb={2}>
        <Button type='submit' variant="contained" color="primary" fullWidth disabled={!isValid || !state.deliveryOption}>
          <Trans>Proceed to payment</Trans>
        </Button>
      </Box>
    </Form>
  )
}

const validationSchema = ({t}) => {
  return Yup.object().shape({
    name: Yup.string()
      .matches(/^[^@]*$/, t("Minimum two parts, only characters allowed"))
      .test('is-two-parts', t('Minimum two parts, only characters allowed'), (value) => {
         return value && value.trim().split(/\s+/).length >= 2;
      })
      .required(t('Name is required')),
    mobile: Yup.string()
      .matches(/^[^@]*$/, t("Cannot contain the '@' symbol"))
      .required(t('Mobile phone is required')),
    email: Yup.string()
      .email(t('Invalid email format'))
      .required(t('Email address is required')),
  })
}

const getValue = (customerInfo, user, field) => {
  if (customerInfo && customerInfo[field]) {
    return customerInfo[field];
  }
  if (user && user[field]) {
    return user[field];
  }
  return "";
}

const mapPropsToValues = ({customerInfo, user}) => {
  return {
    name: getValue(customerInfo, user, 'name'),
    mobile: getValue(customerInfo, user, 'mobile'),
    email: getValue(customerInfo, user, 'email'),
  }
}

export default withTranslation()(withFormik({
  isInitialValid: props => validationSchema(props).isValidSync(mapPropsToValues(props)),
  mapPropsToValues,
  validationSchema,
  handleSubmit(values, {props})  {

    props.onSubmit(values)

  },
})(StorePickupForm));
